(function () {
  if (window.__relatedArticlesBound) return;
  window.__relatedArticlesBound = true;

  // 事件委托：产品页 Related Articles 的「展开/收起」切换。
  // 绑在 document 上，不依赖 .related-articles-toggle 何时插入 DOM
  // （产品 tab 内容可能经 AJAX / innerHTML 重渲染，内联 script 不会重新执行）。
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.related-articles-toggle');
    if (!toggle) return;
    event.preventDefault(); // 阻止 href="#" 导致页面跳到顶部
    var block = toggle.closest('.product-related-articles');
    if (!block) return;
    var expanded = block.classList.toggle('related-articles-expanded');
    toggle.setAttribute('aria-expanded', String(expanded));
  });
})();
